import gql from 'graphql-tag';

import { PostFragments } from './fragments/PostType';
import { CatchFragments } from './fragments/CatchType';
import { ImageFragments } from './fragments/ImageType';
import { UserFragments } from './fragments/UserType';

export const getBrandPosts = gql`
  query GetBrandPosts {
    posts(
      last: 20
      filters: { postedByBrand: true, topLevel: true, published: true, withoutSharingPosts: true }
    ) {
      edges {
        node {
          ...PostId
          ...PostDisplayEntities
          catch {
            ...CatchId
            ...CatchFishingWaterName
            ...CatchSpeciesName
          }
          comments {
            totalCount
          }
          createdAt
          displayProductUnits {
            totalCount
          }
          ...PostProductUnits
          ...PostVideoFields
          images(first: 10, croppingStrategy: SMART, height: 400, width: 400) {
            totalCount
            edges {
              node {
                ...ImageFields
              }
            }
          }
          likedByCurrentUser
          likesCount
          text {
            text
          }
          user {
            ...UserId
            ...UserAvatar
            nickname
          }
        }
      }
    }
  }
  ${CatchFragments.id}
  ${CatchFragments.fishingWaterName}
  ${CatchFragments.speciesName}
  ${PostFragments.productUnits}
  ${PostFragments.id}
  ${PostFragments.displayEntities}
  ${PostFragments.productUnits}
  ${PostFragments.videoFields}
  ${ImageFragments.imageFields}
  ${UserFragments.id}
  ${UserFragments.avatar}
`;
